import { Helmet } from "react-helmet";
import { useAuthentication } from "~/hooks/util";
import { ApplicationRoutes } from "~/routes";

const LayoutHelmet = () => {
  return (
    <Helmet>
      <body className="min-h-screen bg-background dark" />
    </Helmet>
  );
};

function App() {
  useAuthentication();

  return (
    <>
      <LayoutHelmet />
      <ApplicationRoutes />
    </>
  );
}

export default App;
